export class ContractDocument {
  contractPdfId: number;
  contractId: number;
  contractFileName: string;
  contractFileGuid: string;
  createdBy: string;
  createdDate: Date;
}
